import dayjs from 'dayjs'

// This can be removed when we switch all charts and graphs over to the new reporting endpoints.
// The new reporting endpoints (reporting service) allow to do more custom filtering on data.
export const SHARE_OF_VOICE_PROD_DEPLOYMENT_DATE = dayjs('2024-03-11')
